/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_None_OptionInputs */



/**
* | output |
* | --- |
* | "None" |
*
* @param {Style_Guide_None_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_none_option = /** @type {((inputs?: Style_Guide_None_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_None_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keiner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Никто")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ninguno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有任何")
	if (locale === "ja") return /** @type {LocalizedString} */ ("なし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum")
	return /** @type {LocalizedString} */ ("None")
});